/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfigureBannerRequest
 */
export interface ConfigureBannerRequest {
    /**
     * 
     * @type {Date}
     * @memberof ConfigureBannerRequest
     */
    bannerStartUtc: Date;
    /**
     * 
     * @type {Date}
     * @memberof ConfigureBannerRequest
     */
    maintenanceStartUtc: Date;
    /**
     * 
     * @type {Date}
     * @memberof ConfigureBannerRequest
     */
    maintenanceEndUtc: Date;
    /**
     * 
     * @type {string}
     * @memberof ConfigureBannerRequest
     */
    message: string | null;
}

/**
 * Check if a given object implements the ConfigureBannerRequest interface.
 */
export function instanceOfConfigureBannerRequest(value: object): value is ConfigureBannerRequest {
    if (!('bannerStartUtc' in value) || value['bannerStartUtc'] === undefined) return false;
    if (!('maintenanceStartUtc' in value) || value['maintenanceStartUtc'] === undefined) return false;
    if (!('maintenanceEndUtc' in value) || value['maintenanceEndUtc'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function ConfigureBannerRequestFromJSON(json: any): ConfigureBannerRequest {
    return ConfigureBannerRequestFromJSONTyped(json, false);
}

export function ConfigureBannerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigureBannerRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'bannerStartUtc': (new Date(json['bannerStartUtc'])),
        'maintenanceStartUtc': (new Date(json['maintenanceStartUtc'])),
        'maintenanceEndUtc': (new Date(json['maintenanceEndUtc'])),
        'message': json['message'],
    };
}

export function ConfigureBannerRequestToJSON(json: any): ConfigureBannerRequest {
    return ConfigureBannerRequestToJSONTyped(json, false);
}

export function ConfigureBannerRequestToJSONTyped(value?: ConfigureBannerRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'bannerStartUtc': value['bannerStartUtc'].toISOString(),
        'maintenanceStartUtc': value['maintenanceStartUtc'].toISOString(),
        'maintenanceEndUtc': value['maintenanceEndUtc'].toISOString(),
        'message': value['message'],
    };
}

